import React, { useState, useEffect, createContext, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { AppStore } from "../app/store";
import routes from "../app/routes";
import { HomeIcon } from "./SvgIcons";
import { AnalyticsActionType } from "../app/contexts/Analytics/types";

export interface ReferrerContextValues {
  goBackTextId: string;
  icon?: React.ReactElement;
}

export const routeReferrerContextMappings = {
  [routes.searchResults]: {
    goBackTextId: "app.terms.go_back_to_search_results",
  },
  [routes.comparePlans]: {
    goBackTextId: "app.terms.go_back_to_plan_compare",
  },
  [routes.yearOverYear]: {
    goBackTextId: "app.terms.go_back_to_year_over_year",
  },
  [routes.summary.landingPage]: {
    goBackTextId: "summary_page.title",
    icon: <HomeIcon />,
  },
  default: {
    goBackTextId: "app.terms.start_a_new_search",
  },
};

const initialState = { goBackTextId: "" } as ReferrerContextValues;
export const ReferrerContext = createContext(initialState);

const ReferrerDetector: React.FunctionComponent<RouteComponentProps> = ({
  location,
  children,
}) => {
  const { pathname } = location;
  const { state, dispatch } = useContext(AppStore.AppContext);
  const [previousLocation, setPreviousLocation] = useState("");
  const [contextValues, setContextValues] = useState(initialState);
  const flags = useFlags();
  const { mctCurrentPlanYear } = flags;

  useEffect(() => {
    if (previousLocation !== pathname) {
      setPreviousLocation(pathname);

      switch (previousLocation) {
        case routes.searchResults:
          setContextValues(routeReferrerContextMappings[routes.searchResults]);
          break;
        case routes.comparePlans:
          setContextValues(routeReferrerContextMappings[routes.comparePlans]);
          break;
        case routes.yearOverYear:
          setContextValues(routeReferrerContextMappings[routes.yearOverYear]);
          break;
        case routes.summary.landingPage:
          setContextValues(
            routeReferrerContextMappings[routes.summary.landingPage]
          );
          break;
        default:
          setContextValues(routeReferrerContextMappings.default);
          break;
      }
    }

    if (state.tealiumLoaded) {
      dispatch({
        type: AnalyticsActionType.SEND_UTAG_PAGE_VIEW,
        settings: {
          page_name: pathname
            .replace("/", "")
            .split("/", 1)
            .join("")
            .replace(/-/g, " "),
          location,
          mctCurrentPlanYear,
        },
      });
    }
  }, [pathname, state.tealiumLoaded]);

  return (
    <ReferrerContext.Provider
      value={{
        goBackTextId: contextValues.goBackTextId,
        icon: contextValues.icon,
      }}
    >
      {children}
    </ReferrerContext.Provider>
  );
};

export default withRouter(ReferrerDetector);
